import { DefaultRow } from "@pdf/helpers/default-row/default-row";
import { jsPDF } from "jspdf";

export class ImagesRow extends DefaultRow {
  readonly number: string[];
  readonly displayName: string[];
  readonly name: string[];
  readonly notes: string[];

  constructor(pdf: jsPDF, number: string[], displayName: string[], name: string[], notes: string[]) {
    super();
    this.number = number;
    this.displayName = displayName;
    this.name = name;
    this.notes = notes;
    this._textHeight = this.calculateRowTextHeight(pdf);
    this._rowHeight = this.calculateRowHeight(this.textHeight);
  }
  private calculateRowTextHeight(pdf: jsPDF) {
    return Math.max(
      ...[
        this.calculateCellTextHeight(pdf, this.number),
        this.calculateCellTextHeight(pdf, this.displayName),
        this.calculateCellTextHeight(pdf, this.name),
        this.calculateCellTextHeight(pdf, this.notes),
      ],
    );
  }
}
